module.exports = __webpack_public_path__ + "img/kaiertup1.d9689871.jpg";